import Navbar from '@/components/Navbar/Navbar'
import Footer from '@/components/Footer/Footer'
import WhatsAppButton from '../components/Home/WhatsAppButton'

const MainLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <WhatsAppButton />
      <Footer />
    </>
  )
}

export default MainLayout
